exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".winres-web-component .close-button.exitBtn{z-index:9999;color:#fff;background-color:transparent;margin-top:9px;margin-right:12px}.destination-images-carousel .not-carousel{height:30vw;min-width:800px;background-size:cover!important;background-position:50%!important}.destination-images-carousel-no-bg .not-carousel-no-bg{height:auto}.not-carousel{min-height:244px;background-size:cover!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?sourceMap&includePaths[]=/home/jenkins/work/workspace/Lumo_deploy_feature-test-3/~/breakpoint-sass/stylesheets!./src/webComponents/styles/custom/Youtravel.nopostcss.sass
// module id = 672
// module chunks = 2